import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom'; // Assuming NavLinks are React Router NavLinks
import logo from "../../images/SPE.png"
import NavLinks from '../Navbar/NavLinks';

const NavBar = () => {
    const [top, setTop] = useState(!window.scrollY);
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
        setIsOpen(!isOpen);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    useEffect(() => {
      const scrollHandler = () => {
        window.pageYOffset > 10 ? setTop(false) : setTop(true)
      };
      window.addEventListener('scroll', scrollHandler);
      return () => window.removeEventListener('scroll', scrollHandler);
    }, [top]);

    return (
        <nav className={`fixed top-0 w-full z-30 transition duration-300 ease-in-out mb-16 ${!top && 'bg-white shadow-lg'}`}>
            <div className="flex flex-row justify-between items-center py-2">
                <div className="flex flex-row justify-center md:px-12 md:mx-12 items-center text-center font-semibold">
                    <img src={logo} width={200} alt="logo" />
                </div>
                <div className="hidden lg:flex flex-row items-center " style={{marginLeft:'190px'}}>
                    <NavLinks onClose={handleClose} />
                </div>
                <div className="group flex flex-col items-center">
                    <button className="p-2 rounded-lg lg:hidden text-blue-900" onClick={handleClick}>
                        {isOpen ? (
                            <svg className="h-6 w-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path fillRule="evenodd" clipRule="evenodd" d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z" />
                            </svg>
                        ) : (
                            <svg className="h-6 w-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path fillRule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z" />
                            </svg>
                        )}
                    </button>
                     <div className={`fixed inset-0 bg-opacity-50 bg-gray-900 transition-opacity duration-300 ${isOpen ? "opacity-100" : "opacity-0 pointer-events-none"}`} style={{ backdropFilter: "blur(5px)",WebkitBackdropFilter: "blur(5px)", display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={handleClose}>
                        <div className="fixed top-14 right-10 h-auto rounded-md p-2 lg:hidden shadow-xl" style={{ background: 'linear-gradient(#2095A1, white)', width: "80%" }}>
                            <div className='flex flex-col space-y-6 items-center'>
                                <img src={logo} width={200} alt="logo" className="mx-auto" />
                                <NavLinks onClose={handleClose} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default NavBar;
